<script>
import XEUtils from 'xe-utils'
import AssayAddress from '@/components/address/assayAddress.vue'

export default {
  data() {
    return {
      data: {},
      show: false,
      rules: {
        longitude: [{ required: true, message: '请输入经度', trigger: 'change' }],
        latitude: [{ required: true, message: '请输入纬度', trigger: 'change' }],
      },
      name: '',
      loading: false,
    }
  },
  components: { AssayAddress },
  methods: {
    display(event) {
      this.$set(this, 'data', XEUtils.clone(event.data, true))
      this.$set(this, 'name', '更新化验室')
      this.$set(this, 'show', true)
      this.$set(this, 'loading', false)
    },
    handleSave() {
      this.$refs.formRef.validate((vali) => {
        if (vali) {
          this.$set(this, 'loading', true)
          const params = {
            name: this.data.name,
            address: this.data.address,
            longitude: this.data.longitude,
            latitude: this.data.latitude,
            province: this.data.province,
            city: this.data.city,
            district: this.data.district,
            id: this.data.id
          }
          this.$axios.post('/paas/eventEmit/emit/coal_laboratory/coal_laboratory_update', params).then(() => {
            this.$message.success({ showClose: true, message: '更新成功' })
            this.$emit('init')
            this.$set(this, 'loading', false)
            this.$set(this, 'show', false)
          }).catch(() => {
            this.$set(this, 'loading', false)
          })
        } else {
          return false
        }
      })
    },
    updateModelData(event) {
      this.$set(this.data, 'address', event.address)
      this.$set(this.data, 'longitude', event.longitude)
      this.$set(this.data, 'latitude', event.latitude)
      this.$set(this.data, 'province', event.province)
      this.$set(this.data, 'city', event.city)
      this.$set(this.data, 'district', event.district)
    }
  }
}
</script>
<template>
  <el-dialog :visible.sync="show" :title="name" width="1000px" top="0">
    <el-form ref="formRef" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
      <el-row :gutter="20" style="display: flex; flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item prop="name" label="化验室名称">
            <el-input v-model="data.name" placeholder="请输入化验室名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="address" label="地址">
            <assay-address :model-value="data.address" :model-data="data" @update-modelData="updateModelData" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="longitude" label="经度">
            <el-input v-model="data.longitude" placeholder="请输入经度"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="latitude" label="纬度">
            <el-input v-model="data.latitude" placeholder="请输入纬度"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="handleSave" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>